export default __webpack_public_path__ + "static/snowflake_b.97b99e64c24e687ffe95bbe0d63b701d.png";